import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@streamr/tv-ui';
import { useRef } from 'react';
import styled from 'styled-components';
import { BroadcastService } from '../../../services/broadcast/BroadcastService';
import { BroadcastStateService } from '../../../services/broadcaststate/BroadcastStateService';
import { RecordingService } from '../../../services/recording/RecordingService';
import { Anchor } from '../../Anchor';
import { PopupCssPreset } from '../../popups/Popup.styles';
import { showStopRecordingPopup, } from '../../popups/recording/StopRecordingPopup';
const mobilePositioningForStopRecordingPopup = {
    fullscreenOnly: true,
};
const desktopPositioningForStopRecordingPopup = {
    fullscreenOnly: false,
    popupCssPresetForDesktop: PopupCssPreset.AnchoredTopCenter,
};
export function ToggleLiveButton(props) {
    const { className, device, disabled } = props;
    const anchorRef = useRef(null);
    const broadcastService = BroadcastService.getNotificationInterface();
    const broadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const recordingService = RecordingService.getNotificationInterface();
    const activeRecording = RecordingService.getOutput().useActiveRecording();
    const broadcastOutputBroadcasting = BroadcastService.getOutput().useBroadcasting();
    return broadcastOutputBroadcasting ? (_jsx(Anchor, { ref: anchorRef, children: _jsx(ToggleLiveButtonRoot, { className: className, type: "button", "$device": device, onClick: async () => {
                if (activeRecording &&
                    activeRecording.status === 'recording') {
                    const shouldStop = await showStopRecordingPopup({
                        anchorRef,
                        positioning: device === 'mobile'
                            ? mobilePositioningForStopRecordingPopup
                            : desktopPositioningForStopRecordingPopup,
                        broadcast,
                        isPublic: activeRecording.visibility === 'public',
                    });
                    if (shouldStop) {
                        recordingService.notifyStopRecording(() => {
                            broadcastService.notifyStopBroadcast();
                        });
                    }
                    return;
                }
                recordingService.notifyStopRecording(() => {
                    broadcastService.notifyStopBroadcast();
                });
            }, "$isLive": true, disabled: activeRecording?.status === 'stopping', children: "End" }) })) : (_jsx(ToggleLiveButtonRoot, { "$device": device, className: className, type: "button", onClick: () => {
            broadcastService.notifyStartBroadcast();
        }, "$isLive": false, disabled: disabled, children: "Go Live" }));
}
const ToggleLiveButtonRoot = styled(Button) `
    --Button_Background: ${({ $isLive }) => ($isLive ? 'var(--tv-ui-color-6)' : 'var(--tv-ui-color-3)')};
    --Button_HoverBackground: ${({ $isLive }) => ($isLive ? 'var(--tv-ui-color-6)' : 'var(--tv-ui-color-3)')};
    --Button_TextColor: ${({ $isLive }) => ($isLive ? 'var(--tv-ui-color-3)' : 'var(--tv-ui-color-1)')};
    --Button_Padding: ${({ $device }) => ($device === 'mobile' ? '0 1rem' : '0 1.5rem')};
    --Button_BorderRadius: 1.5rem;
    --Button_Height: 3rem;
`;
